export default {
  userInfo: state => {
    return state.user_info;
  }
};
